import FiltersView from './Filters.View';

type FiltersProps = {
  onFilterPlan: (selectedPlans: string[]) => void;
  onFilterSpend: (selectedItems: string[]) => void;
  clearFilters: () => void;
  onIncludeLockedBrands: (exclude: boolean) => void;
  includeLockedBrands: boolean;
  hasSelectedFilters: boolean;
};

const Filters = ({
  onFilterPlan,
  onFilterSpend,
  clearFilters,
  includeLockedBrands,
  onIncludeLockedBrands,
  hasSelectedFilters
}: FiltersProps) => (
  <FiltersView
    includeLockedBrands={includeLockedBrands}
    onIncludeLockedBrands={onIncludeLockedBrands}
    hasSelectedFilters={hasSelectedFilters}
    onFilterPlan={onFilterPlan}
    onFilterSpend={onFilterSpend}
    clearFilters={clearFilters}
  />
);

export default Filters;
